export default class Ratings {
    constructor(options) {
        this.container = options.container || document.body;
        this.handleReload();
    }

    handleReload() {}
}
